import { toast } from "react-toastify";

import * as loginReducer from "containers/Login/reducer";
import * as accountsReducer from "containers/Accounts/reducer";

const UPDATE_FIELD = "lookerSettings/UPDATE_FIELD";

const initialState = {
  isOpen: false,
  aible_looker_models_repo_uuid: undefined,
  aible_workspace_uuid: undefined,
  aible_bitbucket_creds_user: undefined,
  aible_bitbucket_creds_secret: undefined,
  aible_connection_name: undefined,
  lookerUserAttributes: {}
};

function lookerSettingsReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getLookerSettings(state) {
  return state.lookerSettings;
}

export function getIsOpen(state) {
  return getLookerSettings(state)?.isOpen;
}

export function getLookerModelsRepoUUID(state) {
  return getLookerSettings(state)?.aible_looker_models_repo_uuid;
}

export function getWorkspaceId(state) {
  return getLookerSettings(state)?.aible_workspace_uuid;
}

export function getBitbucketCredsUser(state) {
  return getLookerSettings(state)?.aible_bitbucket_creds_user;
}

export function getBitbucketCredsSecret(state) {
  return getLookerSettings(state)?.aible_bitbucket_creds_secret;
}

export function getBitbucketCreds(state) {
  return btoa(getBitbucketCredsUser(state) + ":" + getBitbucketCredsSecret(state));
}

export function getConnectionName(state) {
  return getLookerSettings(state)?.aible_connection_name;
}

export function getLookerModelFile(state) {
  return getLookerSettings(state)?.aible_model_file;
}

export function getLookerModelName(state) {
  const modelFile = getLookerModelFile(state);
  return modelFile.replace(".model.lkml", "");
}

export function getLookerProjectName(state) {
  return getLookerSettings(state)?.aible_looker_project_name;
}

export function getLookerUserAttributes(state) {
  return getLookerSettings(state)?.lookerUserAttributes;
}

export function getHasAllAttributes(state) {
  return (
    getLookerModelsRepoUUID(state) !== undefined &&
    getWorkspaceId(state) !== undefined &&
    getBitbucketCredsUser(state) !== undefined &&
    getBitbucketCredsSecret(state) !== undefined &&
    getLookerModelFile(state) !== undefined &&
    getLookerProjectName(state) !== undefined
  );
}

/* Actions */
export function updateIsOpen(isOpen) {
  return { type: UPDATE_FIELD, data: isOpen, key: "isOpen" };
}

export function updateLookerModelsRepoUUID(aible_looker_models_repo_uuid) {
  return {
    type: UPDATE_FIELD,
    data: aible_looker_models_repo_uuid,
    key: "aible_looker_models_repo_uuid"
  };
}

export function updateWorkspaceId(aible_workspace_uuid) {
  return {
    type: UPDATE_FIELD,
    data: aible_workspace_uuid,
    key: "aible_workspace_uuid"
  };
}

export function updateConnectionName(aible_connection_name) {
  return {
    type: UPDATE_FIELD,
    data: aible_connection_name,
    key: "aible_connection_name"
  };
}

export function updateModelFile(aible_model_file) {
  return {
    type: UPDATE_FIELD,
    data: aible_model_file,
    key: "aible_model_file"
  };
}

export function updateLookerProjectName(aible_looker_project_name) {
  return {
    type: UPDATE_FIELD,
    data: aible_looker_project_name,
    key: "aible_looker_project_name"
  };
}

export function updateBitbucketCredsUser(aible_bitbucket_creds_user) {
  return {
    type: UPDATE_FIELD,
    data: aible_bitbucket_creds_user,
    key: "aible_bitbucket_creds_user"
  };
}

export function updateBitbucketCredsSecret(aible_bitbucket_creds_secret) {
  return {
    type: UPDATE_FIELD,
    data: aible_bitbucket_creds_secret,
    key: "aible_bitbucket_creds_secret"
  };
}

export function updateLookerUserAttributes(lookerUserAttributes) {
  return {
    type: UPDATE_FIELD,
    data: lookerUserAttributes,
    key: "lookerUserAttributes"
  };
}

export function handleFetchAttributes(attributes) {
  return (dispatch, getState) => {
    if (attributes?.value === undefined) {
      return Promise.resolve();
    }

    const aible_looker_models_repo_uuid = attributes.value.find((a) => a.name === "aible_looker_models_repo_uuid");
    const aible_workspace_uuid = attributes.value.find((a) => a.name === "aible_workspace_uuid");
    const aible_connection_name = attributes.value.find((a) => a.name === "aible_connection_name");
    const aible_bitbucket_creds_user = attributes.value.find((a) => a.name === "aible_bitbucket_creds_user");
    const aible_bitbucket_creds_secret = attributes.value.find((a) => a.name === "aible_bitbucket_creds_secret");
    const aible_model_file = attributes.value.find((a) => a.name === "aible_model_file");
    const aible_looker_project_name = attributes.value.find((a) => a.name === "aible_looker_project_name");

    /*
    const aible_looker_model_name = attributes.value.find(
      (a) => a.name === "aible_looker_model_name"
    );
    */

    if (aible_model_file !== undefined) {
      dispatch(updateModelFile(aible_model_file.value));
    }
    if (aible_looker_models_repo_uuid !== undefined) {
      dispatch(updateLookerModelsRepoUUID(aible_looker_models_repo_uuid.value));
    }
    if (aible_workspace_uuid !== undefined) {
      dispatch(updateWorkspaceId(aible_workspace_uuid.value));
    }
    if (aible_connection_name !== undefined) {
      dispatch(updateConnectionName(aible_connection_name.value));
    }
    if (aible_bitbucket_creds_user !== undefined) {
      dispatch(updateBitbucketCredsUser(aible_bitbucket_creds_user.value));
    }
    if (aible_bitbucket_creds_secret !== undefined) {
      dispatch(updateBitbucketCredsSecret(aible_bitbucket_creds_secret.value));
    }
    if (aible_looker_project_name !== undefined) {
      dispatch(updateLookerProjectName(aible_looker_project_name.value));
    }

    /*
    if (aible_looker_model_name !== undefined) {
      dispatch(updateLookerModelName(aible_looker_model_name.default_value));
    }
    */

    dispatch(updateLookerUserAttributes(attributes));
  };
}

export function saveSettings(settings) {
  return async (dispatch, getState) => {
    const currentUserAttributes = getLookerUserAttributes(getState());
    const coreSDK = loginReducer.getLookerAPIClient(getState());

    console.log("saving settings", settings);

    if (settings) {
      const fSettings = Object.keys(settings).filter((sKey) => settings[sKey] !== undefined);
      for (const sKey of fSettings) {
        const foundAttribute =
          currentUserAttributes?.value === undefined
            ? undefined
            : currentUserAttributes.value.find((a) => a.name === sKey);

        if (foundAttribute) {
          const uResponse = await coreSDK.update_user_attribute(foundAttribute?.id, {
            name: sKey,
            label: sKey,
            type: "string",
            default_value: settings[sKey]
          });
          console.log("update response", uResponse);
        } else {
          const cResponse = await coreSDK.create_user_attribute({
            name: sKey,
            label: sKey,
            type: "string",
            default_value: settings[sKey]
          });
          console.log("create response", cResponse);
        }
      }
    }

    const nUserAttributes = await coreSDK.all_user_attributes({});

    dispatch(handleFetchAttributes(nUserAttributes));

    dispatch(accountsReducer.lookerNavigateToDashboard());

    console.log("what are nUserAttributes? ", nUserAttributes);
  };
}

export default lookerSettingsReducer;
